// extracted by mini-css-extract-plugin
export default {"header":"report-details-root_header__EjoB7","placeHolderShimmer":"report-details-root_placeHolderShimmer__8kZ2l"};